import * as React from "react";
import { Container } from "@mui/material";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";

import Result from "./Result";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default class ResultsGrid extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      successFailureTab: 0,
      chartOpen: false,
      chartData: [],
    };
  }

  render() {
    let successGrids = [];
    let failureGrids = [];

    for (var i = 0; i < this.props.results.length; i++) {
      let component = <Result key={i} data={this.props.results[i]} index={i}></Result>;

      if (this.props.results[i].successful) {
        successGrids.push(component);
      } else {
        failureGrids.push(component);
      }
    }

    return (
      <Container
        style={{
          minWidth: "100%",
        }}
      >
        <h2>
          {this.props.results.length === 0
            ? "Please Run Simulation"
            : `Success Rate: 
              ${Math.round(
                (successGrids.length / this.props.results.length) * 100
              )}%`}
        </h2>
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <Tabs
            value={this.state.successFailureTab}
            onChange={this.tabChange.bind(this)}
          >
            <Tab label={`Successes ${successGrids.length}`} {...a11yProps(0)} />
            <Tab label={`Failures ${failureGrids.length}`} {...a11yProps(1)} />
          </Tabs>

          <TabPanel value={this.state.successFailureTab} index={0}>
            {successGrids}
          </TabPanel>
          <TabPanel value={this.state.successFailureTab} index={1}>
            {failureGrids}
          </TabPanel>
        </Box>
      </Container>
    );
  }

  tabChange(event, newValue) {
    this.setState({ successFailureTab: newValue });
  }
}
